"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Article } from "@/types";

const SimilarArticles = ({ slug }: { slug: string }) => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // ✅ Fetch similar articles based on category
  useEffect(() => {
    const fetchSimilarArticles = async () => {
      if (!slug) return;

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `/api/articles?category=${slug}&pageSize=3`,
        );
        const data = await response.json();

        if (!response.ok) throw new Error("Failed to fetch similar articles");

        setArticles(data.articles || []);
      } catch (err) {
        setError("Erreur lors du chargement des articles similaires.");
      } finally {
        setLoading(false);
      }
    };

    fetchSimilarArticles();
  }, [slug]); // ✅ Runs when `slug` changes

  return (
    <div className="mt-10">
      <h2 className="mb-4 text-xl font-bold">Articles Similaires</h2>

      {loading ? (
        <p className="text-gray-500">Chargement...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : articles.length === 0 ? (
        <p className="text-gray-500">Aucun article similaire trouvé.</p>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {articles.map((article) => (
            <Link
              key={article.id}
              href={`/${article.slug}`}
              className="block rounded-lg border p-4 shadow transition duration-300 hover:shadow-lg"
            >
              <h3 className="text-lg font-semibold">{article.title}</h3>
              <p className="text-sm text-gray-600">{article.published_date}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default SimilarArticles;
